import { ErrorCode, } from "@shared";
/** Which of the editable profile fields differ from what was loaded */
export function profileChanges(original, candidate) {
    return {
        username: candidate.username !== original.username,
        displayName: candidate.displayName !== original.displayName,
        bio: candidate.bio !== original.bio,
    };
}
const saved = { kind: "saved" };
const failed = { kind: "failed" };
function rejected(message) {
    return { kind: "rejected", message };
}
export function usernameResult(resp) {
    if (typeof resp === "object")
        return failed;
    switch (resp) {
        case "success":
            return saved;
        case "username_taken":
            return rejected("register.usernameTaken");
        case "user_not_found":
            return rejected("register.userNotFound");
        case "username_too_short":
            return rejected("register.usernameTooShort");
        case "username_too_long":
            return rejected("register.usernameTooLong");
        case "username_invalid":
            return rejected("register.usernameInvalid");
        case "offline":
            return failed;
        default:
            return resp;
    }
}
export function displayNameResult(resp) {
    if (typeof resp === "object")
        return failed;
    switch (resp) {
        case "success":
            return saved;
        case "user_not_found":
            return rejected("register.userNotFound");
        case "display_name_too_short":
            return rejected("register.displayNameTooShort");
        case "display_name_too_long":
            return rejected("register.displayNameTooLong");
        case "display_name_invalid":
            return rejected("register.displayNameInvalid");
        case "offline":
            return failed;
        default:
            return resp;
    }
}
export function bioResult(resp) {
    switch (resp.kind) {
        case "success":
            return saved;
        case "error":
            return resp.code === ErrorCode.TextTooLong ? rejected("register.bioTooLong") : failed;
        case "offline":
            return failed;
        default:
            return resp;
    }
}
/** How setting the user's name in a community went (setMemberDisplayName). */
export function memberDisplayNameResult(resp) {
    switch (resp.kind) {
        case "success":
            return saved;
        case "error":
            switch (resp.code) {
                case ErrorCode.DisplayNameTooShort:
                    return rejected("register.displayNameTooShort");
                case ErrorCode.DisplayNameTooLong:
                    return rejected("register.displayNameTooLong");
                case ErrorCode.InvalidDisplayName:
                    return rejected("register.displayNameInvalid");
                default:
                    return rejected("unexpectedError");
            }
        case "offline":
            return failed;
        default:
            return resp;
    }
}
/** The link that invites someone to OpenChat on the user's behalf: `origin` is canonicalOrigin(). */
export function referralLink(origin, userId) {
    return `${origin}/?ref=${userId}`;
}
